export const specialColors = [
    '700', 
    '0001', 
    '001', 
    '1', 
    '900', 
    '0001-6-000', 
    '0004-7-700', 
    '004-9-700',
    '900 CRUDO',
    '799',
    '000-6-000',
    '600',
];
